import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GroupJoin from './component/groupJoin/GroupJoin';
import TermsUse from './component/terms-use/TermsUse';
import Privacy from './component/privacy/Privacy';
import LegalDocuments from './component/legal-documents/LegalDocuments';
import Support from './component/support/Support';
import Home from './component/home/Home';
import Splash from './component/splash/Splash';

export const APP_NAME = "Plannits";
export const EMAIL = 'privacy@plannits.es';
export const EMAIL_INFO = 'info@plannits.es';
export const URL_ANDROID = 'https://play.google.com/store/apps/details?id=com.plannits';
export const URL_IOS = 'https://apps.apple.com/es/app/plannits/id6739186250';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/group/:id/join" element={<GroupJoin />} />
        <Route path="/" element={<Splash />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms-use" element={<TermsUse />} />
        <Route path="/legal-documents" element={<LegalDocuments />} />
        <Route path="/support" element={<Support />} />
        <Route path="/home" element={<Home />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

